export enum ECookiesAccept {
  all = 'all',
  some = 'some'
}
